import { ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlType } from '../../enums/control-type.enum';
import { ControlSize } from '../../enums/control-size.enum';

const RadioComponentProvider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => RadioComponent),
  multi: true,
};

@Component({
  selector: 'ideom-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss'],
  providers: [RadioComponentProvider],
})
export class RadioComponent implements ControlValueAccessor {
  /**
   * The flag indicating that control is disabled
   */
  @Input() disabled: boolean;

  /**
   * The input label
   */
  @Input() label: string;

  /**
   * The name of control
   */
  @Input() name: string;

  /**
   * The value of control
   */
  @Input() value: unknown;

  /**
   * The size of control
   */
  @Input() size: ControlSize = ControlSize.Medium;

  /**
   * The type of control
   */
  @Input() type: ControlType = ControlType.Primary;

  /**
   * The control model
   */
  model: unknown;

  /**
   * @ignore
   */
  onChange: (value: unknown) => void;

  /**
   * @ignore
   */
  onTouched: () => void;

  /**
   * @ignore
   * @param changeDetectorRef The Change Detector Ref
   */
  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  /**
   * @ignore
   */
  registerOnChange(fn: (value: unknown) => void): void {
    this.onChange = fn;
  }

  /**
   * @ignore
   */
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  /**
   * @ignore
   */
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.changeDetectorRef.markForCheck();
  }

  /**
   * @ignore
   */
  writeValue(value: boolean | undefined): void {
    this.model = value;
  }

  /**
   * This method is used for emitting updated value
   */
  onChangeValue(model: unknown) {
    this.onTouched && this.onTouched();
    this.onChange && this.onChange(model);
  }

  /**
   * Gets a list of classes to be applied to the control
   */
  generateClasses(checked: boolean): string[] {
    const classes: string[] = [];
    classes.push('radio-' + this.size);
    if (checked) {
      classes.push('background-' + this.type);
    }
    return classes;
  }
}
